module.exports = __webpack_public_path__ + "img/ring_g_s_null_0.48564c85.png";